<template lang="html">
    <section class="section">
        <div class="container">
            <h1 class="title">Moderation interface</h1>
            <div class="columns">
                <div class="column is-2">
                <b-menu>

                    <b-menu-list label="Reporting">
                    <b-menu-item icon="account" label="Last reports">

                    </b-menu-item>

                    <b-menu-item icon="folder-multiple-outline" label="Bans">

                    </b-menu-item>
                    </b-menu-list>

                </b-menu>

                </div>
                <div class="column">
                    <h2 class="subtitle ">Last Reports</h2>
                    <b-field grouped group-multiline>
                        <button class="button field is-success"
                            :disabled="!checkedRows.length">
                            <b-icon icon="check"></b-icon>
                            <span>Review</span>
                        </button>
                        <button class="button field is-danger"
                        :disabled="!checkedRows.length">
                            <b-icon icon="close"></b-icon>
                            <span>Unreview</span>
                        </button>

                    </b-field>
                    <b-table
                        :data="report_table"
                        ref="table"
                        paginated
                        per-page="20"
                        detailed
                        detail-key="id"
                        :row-class="getReportRowClass"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"
                        :checked-rows.sync="checkedRows"
                        default-sort-direction=desc
                        default-sort="reporting_date"
                        checkable
                    >
                        <b-table-column field="id" label="Identifier" width="40" searchable sortable numeric v-slot="props">
                            {{ props.row.id }}
                        </b-table-column>

                        <b-table-column field="reported_item" label="Reported item/user" searchable centered v-slot="props">
                            <router-link :to="{ path: `${ props.row.reported_item }` }">
                                <span class="has-text-dark-orange">{{ props.row.reported_item }}</span>
                            </router-link>
                        </b-table-column>

                        <b-table-column field="reporting_user" label="Reporting user" searchable sortable v-slot="props">
                            <router-link :to="{ path: `/users/${ props.row.reporting_user }` }">
                                <span class="has-text-dark-orange">{{ props.row.reporting_user }}</span>
                            </router-link>
                        </b-table-column>

                        <b-table-column field="reporting_date" label="Reporting date" searchable sortable centered v-slot="props">
                            {{ props.row.reporting_date  }}
                        </b-table-column>

                        <b-table-column field="related_user" label="Reported user" searchable sortable v-slot="props">
                            <router-link :to="{ path: `/users/sakura` }">
                                <span class="has-text-dark-orange">sakura</span>
                            </router-link>
                        </b-table-column>

                        <template slot="detail" slot-scope="props">
                            <div class="columns">
                                <div class="column">
                                    <span class="has-text-gray">Reason: </span>
                                    <span class="is-italic">"{{ props.row.reason }}"</span>
                                </div>
                                <div v-if="reviewed" class="column is-narrow">
                                    <span class="is-italic has-text-gray">Reviewed on</span> <span class="is-italic ">{{ simpleDateFormat(props.row.reviewing_date) }} </span><span class="is-italic has-text-gray">by</span><span class="is-italic"> {{props.row.reviewer}} </span>
                                </div>
                            </div>
                        </template>
                    </b-table>
                    <h2 class="subtitle ">Bans</h2>
                    <b-field grouped group-multiline>

                        <button @click="isNewBanModalActive = true" class="button field is-danger">
                            <b-icon icon="cancel"></b-icon>
                            <span class="has-text-weight-bold">New ban</span>
                        </button>

                        <b-button @click="promptUnban" type="is-warning" icon-pack="mdi" icon-left="check-outline">
                            Cancel ban
                        </b-button>
                    </b-field>

                    <b-table
                        :data="ban_table"
                        ref="table"
                        paginated
                        per-page="20"
                        detailed
                        detail-key="id"
                        :row-class="getBanRowClass"
                        aria-next-label="Next page"
                        aria-previous-label="Previous page"
                        aria-page-label="Page"
                        aria-current-label="Current page"

                        default-sort-direction=desc
                        default-sort="banning_date"

                    >
                        <b-table-column field="id" label="Identifier" width="40" searchable sortable numeric v-slot="props">
                            {{ props.row.id }}
                        </b-table-column>

                        <b-table-column field="banned_item" label="Banned item/user" searchable sortable v-slot="props">
                            <router-link :to="{ path: `${ props.row.banned_item }` }">
                                <span class="has-text-dark-orange">{{ props.row.banned_item }}</span>
                            </router-link>
                        </b-table-column>

                        <b-table-column field="banning_date" label="Banning date" searchable sortable centered v-slot="props">
                            {{ props.row.banning_date  }}
                        </b-table-column>

                        <b-table-column field="banning_period" label="Banning period" searchable centered v-slot="props">
                            {{ props.row.banning_period }} days
                        </b-table-column>

                        <b-table-column field="reason" label="Reason" searchable centered v-slot="props">
                            {{ props.row.reason }}
                        </b-table-column>

                        <b-table-column field="related_user" label="Related user" searchable sortable v-slot="props">
                            <router-link :to="{ path: `/users/${ props.row.banned_item }` }">
                                <span class="has-text-dark-orange">sakura</span>
                            </router-link>
                        </b-table-column>

                        <template slot="detail" slot-scope="props">
                            <div class="columns">
                                <div class="column">
                                    <span class="has-text-gray">Internal note: </span>
                                    <span class="is-italic">"{{ props.row.internal_note }}"</span>
                                </div>
                                <div class="column is-narrow">
                                    <span class="is-italic has-text-gray">Banned on</span> <span class="is-italic ">{{ simpleDateFormat(props.row.banning_date) }} </span><span class="is-italic has-text-gray">by</span><span class="is-italic"> {{props.row.banning_user}} </span>
                                </div>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>

        </div>

    <!-- Modals -->
    <b-modal :active.sync="isNewBanModalActive" :can-cancel="modalCancellable" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <new-ban/>
    </b-modal>

    </section>

</template>

<script>
import { dateMixin } from '@/mixins/dateMixin.js'
import NewBan from './NewBan.vue'
export default {
  mixins: [dateMixin],
  data () {
    return {
      report_table: [
        { 'id': 1, 'reported_item': '/crafts/69', 'reporting_user': 'srozen', 'reporting_date': '2020-10-15 13:43:27', 'reason': 'Too sexy for my eyes', 'reviewer': '', 'reviewing_date': '' },
        { 'id': 2, 'reported_item': '/users/aetheya', 'reporting_user': 'srozen', 'reporting_date': '2016-10-15 13:43:27', 'reason': 'Too sexy for my eyes', 'reviewer': '', 'reviewing_date': '' },
        { 'id': 3, 'reported_item': '/crafts/69', 'reporting_user': 'srozen', 'reporting_date': '2016-10-15 16:43:27', 'reason': 'Too sexy for my eyes', 'reviewer': 'srozen', 'reviewing_date': '2016-10-15 13:43:27' }
      ],
      ban_table: [
        { 'id': 1, 'banned_item': '/users/aetheya', 'banning_user': 'srozen', 'banning_date': '2020-10-15 13:43:27', 'banning_period': '365', 'reason': 'Discrimination', 'internal_note': 'Coucou haha', 'status': 'cancelled' },
        { 'id': 2, 'banned_item': '/crafts/65', 'banning_user': 'srozen', 'banning_date': '2020-10-15 13:43:27', 'banning_period': '1', 'reason': 'Discrimination', 'internal_note': 'Hihi hoho', 'status': 'active' },
        { 'id': 3, 'banned_item': '/crafts/65', 'banning_user': 'srozen', 'banning_date': '2020-10-15 13:43:27', 'banning_period': '1', 'reason': 'Discrimination', 'internal_note': 'Hihi hoho', 'status': 'inactive' }
      ],
      checkedRows: [],
      isNewBanModalActive: false,

      modalCancellable: [true, true, false]
    }
  },
  components: {
    NewBan
  },
  methods: {
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    },
    getReportRowClass (row, index) {
      if (index < 2) return 'is-pending'
      else return 'is-reviewed'
    },
    getBanRowClass (row, index) {
      if (row.status === 'active') return 'is-active'
      else if (row.status === 'cancelled') return 'is-cancelled'
      else return 'is-inactive'
    },
    promptUnban () {
      this.$buefy.dialog.prompt({
        message: `What is the ID of the ban you want to cancel?`,
        inputAttrs: {
          type: 'number',
          placeholder: 'Type the ban ID',
          value: '',
          maxlength: 10,
          min: 1
        },
        trapFocus: true,
        onConfirm: (value) =>
          this.$buefy.dialog.confirm({
            title: 'Cancel a ban',
            message: `Are you sure you want to <b>cancel</b> the ban n°${value} on the user XXX?`,
            confirmText: 'Cancel Ban',
            cancelText: 'Close',
            type: 'is-warning',
            hasIcon: true,
            onConfirm: () => this.$buefy.toast.open(`Ban n°${value} cancelled!`)
          })
      })
    }

  },
  computed: {
    reviewed () {
      return true
    }
  }
}
</script>

<style lang="scss" >
tr.is-reviewed {
        background: #daedbd;
        color: #4a4a4a;
    }
tr.is-pending {
        background: #ffefb0;
        color: #4a4a4a;
    }
tr.is-active {
        background: #ffc0b0;
        color: #4a4a4a;
    }
tr.is-cancelled {
        background: #ffefb0;
        color: #4a4a4a;
    }
tr.is-inactive {
        background: #faebeb;
        color: #4a4a4a;
    }
</style>
